/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, message, Upload } from 'antd';

import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';

import { downloadOsUploadAsPdf } from '../API/osWorkOrderApi';

export const WORD_LIKE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.docm',
  '.dot',
  '.dotx',
  '.dotm',
  '.odt',
  '.ott',
  '.rtf',
];
export const MAX_OS_UPLOAD_BYTES = 20 * 1024 * 1024;

export const OS_CATALOG_KIND_WORD = 1;
export const OS_CATALOG_KIND_PDF = 2;

export function isWordLikeOsFile(fileName) {
  const normalizedName = String(fileName || '')
    .trim()
    .toLowerCase();
  return WORD_LIKE_EXTENSIONS.some((extension) => normalizedName.endsWith(extension));
}

export function isPdfOsFile(fileName) {
  const normalizedName = String(fileName || '')
    .trim()
    .toLowerCase();
  return normalizedName.endsWith('.pdf');
}

export function isAcceptedOsCatalogFile(fileName) {
  return isWordLikeOsFile(fileName) || isPdfOsFile(fileName);
}

export function resolveOsCatalogItemKind(fileName) {
  return isPdfOsFile(fileName) ? OS_CATALOG_KIND_PDF : OS_CATALOG_KIND_WORD;
}

export function mergeOsVariableValues(task, form) {
  const values = { ...(task || {}) };
  const formValues = form?.getFieldsValue?.(true);
  if (!formValues) return values;

  Object.entries(formValues).forEach(([key, value]) => {
    if (value !== undefined) values[key] = value;
  });

  return values;
}

function OsUploadDownloadSection({ task, form }) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isConverting, setIsConverting] = useState(false);

  const beforeUpload = (file) => {
    if (!isWordLikeOsFile(file.name)) {
      message.error('Envie apenas arquivos Word e similares.');
      return Upload.LIST_IGNORE;
    }

    if (!file.size || file.size > MAX_OS_UPLOAD_BYTES) {
      message.error('O arquivo deve ter até 20 MB.');
      return Upload.LIST_IGNORE;
    }

    setUploadedFile(file);
    return false;
  };

  const downloadPdf = async () => {
    if (!uploadedFile || isConverting) return;

    setIsConverting(true);
    try {
      await downloadOsUploadAsPdf(uploadedFile, mergeOsVariableValues(task, form));
    } catch (error) {
      message.error('Não foi possível converter o arquivo em PDF.');
    } finally {
      setIsConverting(false);
    }
  };

  return (
    <div
      className="os-work-order-drawer__section-blank os-upload-download-section"
      role="tabpanel"
      aria-label="Upload e Download de OS"
    >
      <div className="os-upload-download-section__option">
        <strong>Upload</strong>
        <Upload
          accept={WORD_LIKE_EXTENSIONS.join(',')}
          maxCount={1}
          showUploadList={false}
          beforeUpload={beforeUpload}
        >
          <Button icon={<UploadOutlined />}>Selecionar arquivo</Button>
        </Upload>
        {uploadedFile && (
          <p className="os-upload-download-section__file-name">{uploadedFile.name}</p>
        )}
      </div>

      <div className="os-upload-download-section__option">
        <strong>Download</strong>
        <Button
          aria-label="Download em PDF"
          icon={<DownloadOutlined />}
          disabled={!uploadedFile}
          loading={isConverting}
          onClick={downloadPdf}
        >
          Download em PDF
        </Button>
      </div>
    </div>
  );
}

export default OsUploadDownloadSection;
